import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListParams, plantAnalyticsInfo } from 'models';
// import { plantAnalyticsInfo, dataPeriodicalAnalytics, ListParams } from 'models';
import { RootState } from '../../app/store';

export interface AnalyticsState {
  loading: boolean;
  analyticsInfo?: any;
  plantAnalytics: plantAnalyticsInfo[];
  error?: string;
}

const initialState: AnalyticsState = {
  loading: false,
  analyticsInfo: undefined,
  error: undefined,
  plantAnalytics: [],
};

const analyticsSlice = createSlice({
  name: 'Analytics',
  initialState,
  reducers: {
    fetchDataOfPlantAnalytics(state, action: PayloadAction<ListParams>) {
      state.loading = true;
      state.plantAnalytics = [];
    },
    fetchDataOfPlantDetailAnalyticsSuccess(state, action: PayloadAction<plantAnalyticsInfo>) {
      state.plantAnalytics = [...state.plantAnalytics, action.payload];
    },
    fetchDataOfPlantAnalyticsSuccess(state) {
      state.loading = false;
      state.error = undefined;
    },
    fetchDataOfPlantAnalyticsFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const analyticsActions = analyticsSlice.actions;

export const selectAnalyticsError = (state: RootState) => state.analyticsReducer.error;
export const selectAnalyticsLoading = (state: RootState) => state.analyticsReducer.loading;
export const selectAnalyticsInfo = (state: RootState) => state.analyticsReducer.analyticsInfo;
export const selectPlantAnalytics = (state: RootState) => state.analyticsReducer.plantAnalytics;

const analyticsReducer = analyticsSlice.reducer;
export default analyticsReducer;
